import React from "react";

const LogoUploader = ({
  type,
  title,
  description,
  size,
  logos,
  handleUpload,
  handleDelete,
  isProcessing,
}) => (
  <div
    className={`logo-uploader 
      ${type === "rectangular" ? "logo-uploader-rectangular" : ""} 
      ${type === "squareWhite" ? "logo-uploader-white" : ""}
      ${type === "squareBlack" ? "logo-uploader-black" : ""}`}
  >
    <div className="logo-uploader-header">
      <h4>{title}</h4>
      <p className="logo-size">{size}</p>
    </div>
    <p className="logo-description">{description}</p>

    <div className="logo-preview-container">
      {isProcessing ? (
        <div className="logo-processing">
          <div className="processing-spinner"></div>
          <p>Processing image...</p>
        </div>
      ) : logos[type] ? (
        <div className="logo-preview">
          <img src={logos[type].url} alt={title} />
          <div className="logo-info">
            <p>Uploaded: {logos[type].name}</p>
          </div>
          <div className="logo-actions">
            <button
              className="spbtn spbtn-blackbkg"
              onClick={() => handleUpload(type)}
            >
              Replace
            </button>
            <button
              className="spbtn spbtn-danger"
              onClick={() => handleDelete(type)}
            >
              Remove
            </button>
          </div>
        </div>
      ) : (
        <div
          className="logo-upload-placeholder"
          onClick={() => handleUpload(type)}
        >
          <div className="upload-icon">+</div>
          <p>Click to upload</p>
          <p className="upload-dimensions">Required size: {size}</p>
          <p className="upload-format">
            PNG or JPEG with transparent background
          </p>
        </div>
      )}
    </div>
  </div>
);

export default LogoUploader;
